<div class="row">
  <div class="col-6 mb-3">
    <label class="secondary-details">{{
      'configuration.customerOnboarding.customerOnboarding' | translate
    }}</label>

    <div class="ps-2 search-bar-group">
      <input
        matInput
        class="pt-2 input-search"
        [(ngModel)]="searchTerm"
        (keyup)="filterBySearch(this.searchTerm)"
        placeholder="{{ 'configuration.customerOnboarding.searchConfiguration' | translate }}" />
    </div>
  </div>

  <div *ngIf="customerOnBoardingVerification == 'VERIFY'" class="col-6 text-start">
    <h6 class="required-field fst-italic">
      {{ 'configuration.customerOnboarding.allConfigurationMandatory' | translate }}
    </h6>
  </div>

  <div *ngIf="customerOnBoardingVerification == 'VERIFY'" class="col-6 text-end icon-mat-close">
    <i mat-dialog-close class="bi bi-x"></i>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <mat-chip-list aria-label="Configuration selection">
      <mat-chip
        *ngFor="let item of filterConfigurationList() | sortBy : 'title' | uniqueBy : 'group_id'"
        [ngClass]="{ 'background-selected-chip': item.group_id === selectedConfiguration }"
        (click)="selectedConfig(item)"
        [selected]="item.group_id === selectedConfiguration">
        {{ item?.translate | translate }}
      </mat-chip>
    </mat-chip-list>
  </div>
</div>

<div class="row no-margin">
  <div class="col-12 m-2 custom-card">
    <div *ngIf="selectedConfiguration === configOnBoarding.OPTIONS">
      <div class="row">
        <div [formGroup]="defaultCurrencyGroup" class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.declaredValueCurrency' | translate
          }}</label
          >:
          <select class="form-control" formControlName="declaredValueCurrency">
            <option value="">
              {{ 'configuration.customerOnboarding.selectCurrency' | translate }}
            </option>
            <option *ngFor="let eachCurrency of defalutCurrency" [value]="eachCurrency">
              {{ eachCurrency }}
            </option>
          </select>
        </div>

        <div [formGroup]="defaultCountryGroup" class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.defaultManufacturingCountry' | translate
          }}</label
          >:
          <select class="form-control" formControlName="manufactureCountry">
            <option>{{ 'configuration.customerOnboarding.selectCountry' | translate }}</option>
            <option *ngFor="let eachListVal of manufactureCountryList" [value]="eachListVal.code">
              {{ eachListVal.name }}
            </option>
          </select>
          <app-error-component [controlName]="defaultCountryGroup.get('manufactureCountry')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group" [formGroup]="defaultIncotermGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.incoterm' | translate
          }}</label>
          :
          <select class="form-control" type="text" formControlName="incoterm">
            <option
              class="option"
              *ngFor="let incoterm of incoterms | dataPropertyGetter"
              [value]="incoterm.key">
              {{ incoterm.key }} - {{ incoterm.value }}
            </option>
          </select>
          <app-error-component
            [controlName]="defaultIncotermGroup.get('incoterm')"></app-error-component>
        </div>

        <div class="col-md-4 form-group" [formGroup]="defaultWeightGroup">
          <label class="required-field"
            >{{ 'configuration.customerOnboarding.shipmentWeight' | translate }} (KG)</label
          >:
          <input formControlName="shipmentWeight" class="form-control" type="text" min="0.1" />
          <app-error-component [controlName]="defaultWeightGroup.get('shipmentWeight')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group" [formGroup]="defaultDecimalGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.unitPriceDecimalValue' | translate
          }}</label
          >:
          <select class="form-control" formControlName="unitPriceDecimalPoints">
            <option *ngFor="let defalutValue of defalutDecValues" [value]="defalutValue">
              {{ defalutValue }}
            </option>
          </select>
          <app-error-component [controlName]="defaultDecimalGroup.get('unitPriceDecimalPoints')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group" [formGroup]="defaultShipmentContent">
          <label>{{
            'configuration.customerOnboarding.shipmentContentsDescription' | translate
          }}</label
          >:
          <input class="form-control" type="text" formControlName="shipmentContentsDescription" />
          <app-error-component
            [controlName]="
              defaultShipmentContent.get('shipmentContentsDescription')
            "></app-error-component>
        </div>
      </div>

      <div class="col-12 mb-2 text-end">
        <button [disabled]="!disableSaveOption()" class="primary-btn" (click)="saveOptions()">
          {{ 'global.save' | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.ACCOUNT_NUMBER">
      <div class="row">
        <h6 class="fw-bold">
          {{ 'configuration.customerOnboarding.motherAccountDetails' | translate }}
        </h6>
      </div>

      <div class="row" [formGroup]="motherAccountGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.shipperAccountNumber' | translate
          }}</label
          >:
          <input formControlName="shipperAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="motherAccountGroup.get('shipperAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.payerAccountNumber' | translate
          }}</label
          >:
          <input formControlName="payerAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="motherAccountGroup.get('payerAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.dutyAccountNumber' | translate }}</label
          >:
          <input formControlName="dutyAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="motherAccountGroup.get('dutyAccountNumber')">
          </app-error-component>
        </div>
      </div>

      <div class="row">
        <h6 class="fw-bold">
          {{ 'configuration.customerOnboarding.babyAccountDetails' | translate }}
        </h6>
      </div>

      <div class="row" [formGroup]="babyAccountGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.shipperAccountNumber' | translate
          }}</label
          >:
          <input formControlName="shipperAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="babyAccountGroup.get('shipperAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.payerAccountNumber' | translate
          }}</label
          >:
          <input formControlName="payerAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="babyAccountGroup.get('payerAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.dutyAccountNumber' | translate }}</label
          >:
          <input formControlName="dutyAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="babyAccountGroup.get('dutyAccountNumber')">
          </app-error-component>
        </div>
      </div>

      <div class="row">
        <h6 class="fw-bold">
          {{ 'configuration.customerOnboarding.individualAccountDetails' | translate }}
        </h6>
      </div>

      <div class="row" [formGroup]="individualShipAccountGroup">
        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.shipperAccountNumber' | translate }}</label
          >:
          <input formControlName="shipperAccountNumber" class="form-control" type="text" />
          <app-error-component
            [controlName]="individualShipAccountGroup.get('shipperAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.payerAccountNumber' | translate }}</label
          >:
          <input formControlName="payerAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="individualShipAccountGroup.get('payerAccountNumber')">
          </app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.dutyAccountNumber' | translate }}</label
          >:
          <input formControlName="dutyAccountNumber" class="form-control" type="text" />
          <app-error-component [controlName]="individualShipAccountGroup.get('dutyAccountNumber')">
          </app-error-component>
        </div>
      </div>

      <div class="col-12 mb-2 text-end">
        <button
          [disabled]="!disableSaveAccountNumbers()"
          class="primary-btn mt-2"
          (click)="saveAccountNumbers()">
          {{ 'global.save' | translate }}
        </button>
      </div>
    </div>
    <!-- Report config -->
    <div *ngIf="selectedConfiguration === configOnBoarding.REPORT_CONFIG">
      <div class="row">
        <h5 class="fw-bold">
          {{ 'configuration.customerOnboarding.reportConfiguration' | translate }}
        </h5>
      </div>
      <div class="row" [formGroup]="reportConfigGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.recipientEmailList' | translate
          }}</label
          ><label>:</label>
          <div class="d-flex align-items-center email-wrapper">
            <input
              formControlName="email"
              class="form-control"
              placeholder="{{
                'configuration.customerOnboarding.EnterEmailIdAndClickButton' | translate
              }}"
              type="text" />
            <i
              [class.disabled]="reportConfigGroup.get('email').errors?.email"
              matTooltip="{{ 'configuration.customerOnboarding.ClickToAddEmail' | translate }}"
              (click)="addEmailIdToList()"
              class="icon-mat bi bi-file-plus"></i>
          </div>
          <app-error-component [controlName]="reportConfigGroup.get('email')"></app-error-component>
          <mat-form-field
            class="example-chip-list"
            style="font-size: 4px"
            style="width: 93%"
            appearance="none">
            <mat-select
              class="form-control"
              placeholder="{{ 'configuration.customerOnboarding.emailList' | translate }}"
              formControlName="EmailList"
              multiple>
              <mat-option *ngFor="let eachId of emailArray" [value]="eachId">
                {{ eachId }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-component
            [controlName]="reportConfigGroup.get('EmailList')"></app-error-component>
        </div>
        <div class="col-md-8 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.emailBodyContents' | translate
          }}</label
          >:
          <textarea
            formControlName="emailBodyContents"
            class="form-control"
            type="text"
            row="2"></textarea>
          <app-error-component [controlName]="reportConfigGroup.get('emailBodyContents')">
          </app-error-component>
        </div>
      </div>
      <div class="col-12 mb-2 text-end">
        <button
          [disabled]="!disableSaveReportConfig()"
          class="primary-btn mt-2"
          (click)="saveReportConfig()">
          {{ 'global.save' | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.PAPERLESS_TRADE">
      <div class="row" [formGroup]="PaperLessTradeGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.paperlessTrade' | translate
          }}</label
          >:
          <select class="form-control" formControlName="paperlessTrade">
            <option disabled value="">
              {{ 'configuration.customerOnboarding.select' | translate }}
            </option>
            <option *ngFor="let eachListVal of paperTradeList" [value]="eachListVal">
              {{ eachListVal }}
            </option>
          </select>
          <app-error-component [controlName]="PaperLessTradeGroup.get('paperlessTrade')">
          </app-error-component>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(PaperLessTradeGroup.valid && PaperLessTradeGroup.dirty)"
            class="primary-btn mt-2"
            (click)="savePaperLessTradeData()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.MOTHER_INCOTERM">
      <div class="row">
        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(MotherIncotermGroup.valid && MotherIncotermGroup.dirty)"
            class="primary-btn mt-2"
            (click)="saveMotherIncoterm()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.IMAGE_PROPERTIES">
      <div class="row">
        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.printerDPI' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="printerDPI">
            <option
              class="option"
              *ngFor="let dpi of imageDocTemplates.printerDpi | dataPropertyGetter"
              [value]="dpi.value">
              {{ dpi.value }}
            </option>
          </select>
          <app-error-component
            [controlName]="ImagePropertiesGroup.get('printerDPI')"></app-error-component>
        </div>

        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.encodingFormat' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="encodingFormat">
            <option
              class="option"
              *ngFor="let type of imageDocTemplates.labelFormat | dataPropertyGetter"
              [value]="type.value">
              {{ type.value }}
            </option>
          </select>

          <app-error-component [controlName]="ImagePropertiesGroup.get('encodingFormat')">
          </app-error-component>
        </div>

        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.label' | translate
          }}</label
          >:
          <select
            class="form-control"
            type="text"
            formControlName="label"
            (change)="setWayBill($event.target.value)">
            <ng-container>
              <option
                class="option"
                *ngFor="let label of labelTypes | dataPropertyGetter"
                [value]="label.value">
                {{ label.key }}
              </option>
            </ng-container>
          </select>
          <app-error-component
            [controlName]="ImagePropertiesGroup.get('label')"></app-error-component>
        </div>

        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.waybillDocPrint' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="print">
            <option class="option" *ngFor="let option of trueFalseOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.invoiceType' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="invoiceType">
            <option
              class="option"
              *ngFor="let invoiceType of imageDocTemplates.invoiceTypes | dataPropertyGetter"
              [value]="invoiceType.value">
              {{ invoiceType.key }}
            </option>
          </select>
          <app-error-component
            [controlName]="ImagePropertiesGroup.get('invoiceType')"></app-error-component>
        </div>

        <div class="col-4 form-group" [formGroup]="labelPrintConfigGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.labelPrint' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="printPieceLevel">
            <option class="option" *ngFor="let type of labelPrintTypes" [value]="type?.value">
              {{ type?.label }}
            </option>
          </select>
          <app-error-component
            [controlName]="labelPrintConfigGroup.get('printPieceLevel')"></app-error-component>
        </div>
        <!--
        <div class="col-4 form-group" [formGroup]="ImagePropertiesGroup">
          <label class="required-field">{{
            'configuration.customerOnboarding.autoPrint' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="autoPrint">
            <option class="option" selected value="false">{{ 'global.no' | translate }}</option>
            <option class="option" value="true">{{ 'global.yes' | translate }}</option>
          </select>
        </div>
        -->
      </div>

      <div class="col-12 mb-2 text-end">
        <button
          [disabled]="!disableLabelPrint()"
          class="primary-btn mt-2"
          (click)="saveLabelDetails()">
          {{ 'global.save' | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.MOTHER_EXPORT_DECLARATION_DETAILS">
      <div class="row" [formGroup]="ExportDeclarationGroup">
        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.description' | translate
          }}</label
          >:
          <input formControlName="description" class="form-control" type="text" />
          <app-error-component [controlName]="ExportDeclarationGroup.get('description')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.signatureName' | translate
          }}</label
          >:
          <input formControlName="signatureName" class="form-control required" type="text" />
          <app-error-component [controlName]="ExportDeclarationGroup.get('signatureName')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.signatureTitle' | translate
          }}</label
          >:
          <input formControlName="signatureTitle" class="form-control" type="text" />
          <app-error-component [controlName]="ExportDeclarationGroup.get('signatureTitle')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.exportReason' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="exportReason">
            <option
              class="option"
              *ngFor="let eachExportReason of exportReasonValues"
              [value]="eachExportReason">
              {{ eachExportReason }}
            </option>
          </select>
          <app-error-component [controlName]="ExportDeclarationGroup.get('exportReason')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.remark' | translate
          }}</label
          >:
          <input formControlName="remark" class="form-control" type="text" />
          <app-error-component
            [controlName]="ExportDeclarationGroup.get('remark')"></app-error-component>
        </div>

        <ng-container [formGroup]="defaultUOMGroup">
          <div class="col-md-3 form-group">
            <label class="required-field">{{
              'configuration.customerOnboarding.invoiceUnitOfMeasurement' | translate
            }}</label
            >:
            <select class="form-control" type="text" formControlName="invoiceUnitOfMeasurement">
              <option
                class="option"
                *ngFor="let uom of uoms | dataPropertyGetter"
                [value]="uom.key">
                {{ uom.key }} - {{ uom.value }}
              </option>
            </select>
            <app-error-component [controlName]="defaultUOMGroup.get('invoiceUnitOfMeasurement')">
            </app-error-component>
          </div>

          <div class="col-md-3 form-group">
            <label class="required-field">{{
              'configuration.customerOnboarding.lineItemQuantity' | translate
            }}</label
            >:
            <select
              class="form-control"
              type="text"
              formControlName="lineItemQuantityUnitofMeasurement">
              <option
                class="option"
                *ngFor="let misurement of lineQuantityMisurements"
                [value]="misurement">
                {{ misurement }}
              </option>
            </select>
            <app-error-component
              [controlName]="defaultUOMGroup.get('lineItemQuantityUnitofMeasurement')">
            </app-error-component>
          </div>
        </ng-container>

        <ng-container [formGroup]="MotherIncotermGroup">
          <div class="col-md-3 form-group">
            <label class="required-field">{{
              'configuration.customerOnboarding.invoiceIncoterm' | translate
            }}</label
            >:
            <select
              class="form-control"
              type="text"
              formControlName="incoterm"
              (change)="setPlaceofIncoterm($event.target.value)">
              <option
                class="option"
                *ngFor="let incoterm of incoterms | dataPropertyGetter"
                [value]="incoterm.key">
                {{ incoterm.key }} - {{ incoterm.value }}
              </option>
            </select>
            <app-error-component
              [controlName]="MotherIncotermGroup.get('incoterm')"></app-error-component>
          </div>

          <div class="col-md-3 form-group">
            <label>{{ 'configuration.customerOnboarding.placeOfIncoterm' | translate }}:</label>
            <select class="form-control" type="text" formControlName="placeofIncoterm">
              <option
                class="option"
                *ngFor="let incotermPlace of placesofIncoterm | dataPropertyGetter"
                [value]="incotermPlace.key">
                {{ incotermPlace.value }}
              </option>
            </select>
            <app-error-component
              [controlName]="MotherIncotermGroup.get('placeofIncoterm')"></app-error-component>
          </div>
        </ng-container>

        <div class="col-md-3 form-group">
          <label>{{ 'configuration.customerOnboarding.signatureImage' | translate }}: </label>
          <div class="d-flex align-items-center">
            <input
              class="form-control"
              type="file"
              formControlName="signatureImage"
              accept="image/png, image/gif, image/jpeg"
              (click)="resetSignatureImage()"
              (change)="onSignatureImageUpload($event)" />
            <i
              *ngIf="signatureImage"
              matTooltip="{{ 'configuration.customerOnboarding.toolTip.view' | translate }}"
              (click)="openView()"
              class="icon-mat bi bi-clipboard-fill"></i>
          </div>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!disableExportDeclOptions()"
            class="primary-btn mt-2"
            (click)="saveExportDeclarations()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        selectedConfiguration === configOnBoarding.INDIVIDUAL_SHIPMENT_EXPORT_DECLARATION_DETAILS
      ">
      <div class="row" [formGroup]="individualShipmentExportDeclarationGroup">
        <div class="col-md-3 form-group">
          <label>{{ 'configuration.customerOnboarding.description' | translate }}</label
          >:
          <input formControlName="description" class="form-control" type="text" />
          <!-- <app-error-component [controlName]="individualShipmentExportDeclarationGroup.get('description')">
          </app-error-component> -->
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.signatureName' | translate
          }}</label
          >:
          <input formControlName="signatureName" class="form-control required" type="text" />
          <app-error-component
            [controlName]="individualShipmentExportDeclarationGroup.get('signatureName')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.signatureTitle' | translate
          }}</label
          >:
          <input formControlName="signatureTitle" class="form-control" type="text" />
          <app-error-component
            [controlName]="individualShipmentExportDeclarationGroup.get('signatureTitle')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.exportReason' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="exportReason">
            <option
              class="option"
              *ngFor="let eachExportReason of exportReasonValues"
              [value]="eachExportReason">
              {{ eachExportReason }}
            </option>
          </select>
          <app-error-component
            [controlName]="individualShipmentExportDeclarationGroup.get('exportReason')">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label>{{ 'configuration.customerOnboarding.remark' | translate }}</label
          >:
          <input formControlName="remark" class="form-control" type="text" />
          <!-- <app-error-component
            [controlName]="individualShipmentExportDeclarationGroup.get('remark')"></app-error-component> -->
        </div>

        <!-- <ng-container [formGroup]="defaultUOMGroup"> -->
        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.invoiceUnitOfMeasurement' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="invoiceUnitOfMeasurement">
            <option class="option" *ngFor="let uom of uoms | dataPropertyGetter" [value]="uom.key">
              {{ uom.key }} - {{ uom.value }}
            </option>
          </select>
          <app-error-component
            [controlName]="
              individualShipmentExportDeclarationGroup.get('invoiceUnitOfMeasurement')
            ">
          </app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.lineItemQuantity' | translate
          }}</label
          >:
          <select
            class="form-control"
            type="text"
            formControlName="lineItemQuantityUnitofMeasurement">
            <option
              class="option"
              *ngFor="let misurement of lineQuantityMisurements"
              [value]="misurement">
              {{ misurement }}
            </option>
          </select>
          <app-error-component
            [controlName]="
              individualShipmentExportDeclarationGroup.get('lineItemQuantityUnitofMeasurement')
            ">
          </app-error-component>
        </div>
        <!-- </ng-container> -->

        <!-- <ng-container [formGroup]="MotherIncotermGroup"> -->
        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.invoiceIncoterm' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="incoterm">
            <option
              class="option"
              *ngFor="let incoterm of incoterms | dataPropertyGetter"
              [value]="incoterm.key">
              {{ incoterm.key }} - {{ incoterm.value }}
            </option>
          </select>
          <app-error-component
            [controlName]="
              individualShipmentExportDeclarationGroup.get('incoterm')
            "></app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label>{{ 'configuration.customerOnboarding.placeOfIncoterm' | translate }}:</label>
          <select class="form-control" type="text" formControlName="placeOfIncoterm">
            <option
              class="option"
              *ngFor="let incotermPlace of placesofIncoterm | dataPropertyGetter"
              [value]="incotermPlace.key">
              {{ incotermPlace.value }}
            </option>
          </select>
          <app-error-component
            [controlName]="
              individualShipmentExportDeclarationGroup.get('placeOfIncoterm')
            "></app-error-component>
        </div>
        <!-- </ng-container> -->

        <div class="col-md-3 form-group">
          <label>{{ 'configuration.customerOnboarding.signatureImage' | translate }}: </label>
          <div class="d-flex align-items-center">
            <input
              class="form-control"
              type="file"
              formControlName="signatureImage"
              accept="image/png, image/gif, image/jpeg"
              (click)="resetSignatureImage()"
              (change)="onSignatureImageUploadForIndShip($event)" />
            <i
              *ngIf="signatureImage"
              matTooltip="{{ 'configuration.customerOnboarding.toolTip.view' | translate }}"
              (click)="openViewIndShip()"
              class="icon-mat bi bi-clipboard-fill"></i>
          </div>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!disableIndividualShipmentExportDeclOptions()"
            class="primary-btn mt-2"
            (click)="saveIndividualShipmentExportDeclarations()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.PACKAGING_CONFIGURATION">
      <app-package></app-package>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.TAX_SETTING">
      <app-taxsetting></app-taxsetting>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.INVOICE_CONFIGURATION">
      <div class="row" [formGroup]="exportInvoiceGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.invoiceType' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="exportInvoice">
            <option
              class="option"
              *ngFor="let eachExportInvoice of exportInvoice"
              [value]="eachExportInvoice?.value">
              {{ eachExportInvoice?.label }}
            </option>
          </select>
          <app-error-component
            [controlName]="exportInvoiceGroup.get('exportInvoice')"></app-error-component>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(exportInvoiceGroup.valid && exportInvoiceGroup.dirty)"
            class="primary-btn m-2"
            (click)="saveExportInvoice()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.CUSTOMER_CREDENTIAL">
      <div class="row" [formGroup]="customerCredentialGroup">
        <div class="col-md-6 mt-1 brd-right">
          <div class="col-md-8 form-group">
            <h6 class="fw-bold">{{ 'configuration.customerOnboarding.myDhlAPI' | translate }}</h6>
            <label [ngClass]="{ 'required-field': dhlKeyReqd }">{{
              'configuration.customerOnboarding.userName' | translate
            }}</label
            >:
            <input
              formControlName="mydhlApiKey"
              (change)="checkFields()"
              class="form-control"
              type="text" />
            <app-error-component
              [controlName]="customerCredentialGroup.get('mydhlApiKey')"></app-error-component>
          </div>
          <div class="col-md-8 form-group">
            <label [ngClass]="{ 'required-field': dhlPswdReqd }">{{
              'configuration.customerOnboarding.password' | translate
            }}</label
            >:
            <div class="input-group">
              <input
                formControlName="mydhlApiPassword"
                (change)="checkFields()"
                class="form-control"
                [type]="fieldTextType ? 'text' : 'password'" />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i
                    class="bi"
                    [ngClass]="{
                      'bi-eye-slash': !fieldTextType,
                      'bi-eye': fieldTextType
                    }"
                    (click)="toggleFieldTextType()"></i>
                </span>
              </div>
            </div>
            <app-error-component
              [controlName]="customerCredentialGroup.get('mydhlApiPassword')"></app-error-component>
          </div>
        </div>
        <div class="col-md-4 form-group mt-1 ps-4">
          <h6 class="fw-bold">
            {{ 'configuration.customerOnboarding.postalLocationAPI' | translate }}
          </h6>
          <label>{{ 'configuration.customerOnboarding.key' | translate }}</label
          >:
          <input
            formControlName="postalLocationApiKey"
            (change)="checkFields()"
            class="form-control"
            type="text" />
          <app-error-component
            [controlName]="
              customerCredentialGroup.get('postalLocationApiKey')
            "></app-error-component>
        </div>
        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(customerCredentialGroup.valid && customerCredentialGroup.dirty)"
            class="primary-btn mt-2"
            (click)="saveCustomerCredential()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.ADDITIONAL_SERVICES">
      <app-additional-services></app-additional-services>
    </div>

    <div
      *ngIf="
        selectedConfiguration === configOnBoarding.SAVE_RECIEVER_ADDRESS && hasAccessToSaveAddress()
      ">
      <app-reciever-save-address></app-reciever-save-address>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.AUTO_PRINT_LABEL">
      <app-autoprintlabel></app-autoprintlabel>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.BBX_CONFIGURATION">
      <div class="row" [formGroup]="bbxConfigGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.workflowType' | translate
          }}</label
          >:
          <select class="form-control" type="text" formControlName="bbxType">
            <option class="option" *ngFor="let type of bbxTypes" [value]="type?.value">
              {{ type?.label }}
            </option>
          </select>
          <app-error-component [controlName]="bbxConfigGroup.get('bbxType')"></app-error-component>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(bbxConfigGroup.valid && bbxConfigGroup.dirty)"
            class="primary-btn m-2"
            (click)="saveBbxConfig()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.BABY_DEFAULT_OPTIONS">
      <div class="row" [formGroup]="babyDefaultOptionsGroup">
        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.babyProductCode' | translate
          }}</label
          >:
          <input
            class="form-control"
            (keyup)="setMotherProductCode()"
            type="text"
            formControlName="productCode" />
          <small
            class="text-danger"
            *ngIf="
              babyDefaultOptionsGroup.get('productCode').errors &&
              babyDefaultOptionsGroup.get('productCode').touched
            ">
            {{ 'configuration.customerOnboarding.PleaseEnterProductCodeAB' | translate }}
          </small>
        </div>

        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.motherProductCode' | translate
          }}</label
          >:
          <input class="form-control" [disabled] type="text" formControlName="motherProductCode" />
          <small
            class="text-danger"
            *ngIf="
              babyDefaultOptionsGroup.get('motherProductCode').errors &&
              babyDefaultOptionsGroup.get('motherProductCode').touched
            ">
            {{ 'configuration.customerOnboarding.PleaseEnterProductCodePH' | translate }}
          </small>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.localProductCode' | translate }}:</label>
          <input class="form-control" type="text" formControlName="localProductCode" />
          <small class="text-danger" *ngIf="babyDefaultOptionsGroup.get('localProductCode').errors">
            {{ 'configuration.customerOnboarding.PleaseEnterProductCodeB' | translate }}
          </small>
        </div>

        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.pleaseEnterTheDescription' | translate
          }}</label
          >:
          <input class="form-control" type="text" formControlName="isCustomsDeclarable" />
          <small
            class="text-danger"
            *ngIf="babyDefaultOptionsGroup.get('isCustomsDeclarable').errors">
            {{ 'configuration.customerOnboarding.pleaseenterFlagYN' | translate }}
          </small>
        </div>

        <div class="col-md-4 form-group">
          <label>{{ 'configuration.customerOnboarding.addDGContentID' | translate }}</label
          >:
          <select
            class="form-control"
            formControlName="showDGContentID"
            (change)="addDgContent($event)">
            <option class="option" selected value="false">{{ 'global.no' | translate }}</option>
            <option class="option" value="true">{{ 'global.yes' | translate }}</option>
          </select>
        </div>

        <div
          class="col-md-4 form-group dg-content"
          *ngIf="babyDefaultOptionsGroup.get('showDGContentID').value">
          <label>{{ 'configuration.customerOnboarding.dgcontentID' | translate }}: </label>
          <mat-form-field appearance="none" class="w-100">
            <mat-select
              disableRipple
              class="form-control"
              formControlName="DGContentID"
              multiple
              (selectionChange)="getDGContentValueChange($event)">
              <mat-option *ngFor="let eachId of DGContentIDValues" [value]="eachId?.dg_content_id">
                {{ eachId?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-component
            [controlName]="babyDefaultOptionsGroup.get('DGContentID')"></app-error-component>
        </div>

        <div
          class="row form-group"
          *ngIf="
            isSpecialProvisionSelected && babyDefaultOptionsGroup.get('showDGContentID').value
          ">
          <div class="d-flex align-items-baseline col-md-4">
            <div class="flex-grow-1">
              <label class="required-field">{{
                'configuration.customerOnboarding.notRestrictedCustomDescription' | translate
              }}</label
              >:
            </div>
            <button
              class="mx-1 icon-mat-header"
              (click)="addCustumDescription()"
              matTooltip="{{ 'configuration.customerOnboarding.addNewDescription' | translate }}"
              mat-raised-button>
              <em class="bi bi-plus"></em>
            </button>
          </div>
          <div class="row py-2">
            <ng-container
              formArrayName="customDescription"
              *ngFor="let creds of getCustumDescriptionArray.controls; let i = index">
              <div class="d-flex align-items-center col-md-4 form-group" [formGroupName]="i">
                {{ i + 1 }}.
                <div class="flex-grow-1">
                  <input
                    class="form-control"
                    type="text"
                    maxlength="200"
                    placeholder="{{ 'configuration.customerOnboarding.description' | translate }}"
                    formControlName="description"
                    (input)="validateCustomDescription()" />
                </div>
                <em
                  class="icon-mat bi bi-trash"
                  (click)="deleteDescription(i)"
                  matTooltip="{{
                    'configuration.customerOnboarding.deleteDescription' | translate
                  }}"></em>
              </div>
              <small
                class="text-danger"
                *ngIf="babyDefaultOptionsGroup.get('customDescription').errors"
                >{{
                  'configuration.customerOnboarding.pleaseEnterTheDescription' | translate
                }}</small
              >
            </ng-container>
          </div>
        </div>

        <div class="col-md-4 form-group dg-content">
          <label>{{ 'configuration.customerOnboarding.productName' | translate }}: </label>
          <mat-form-field appearance="none" class="w-100">
            <mat-select
              disableRipple
              class="form-control"
              formControlName="productName"
              multiple
              (selectionChange)="getProductNameValueChange($event)">
              <mat-option
                *ngFor="let eachId of individualProductCodes"
                [value]="eachId?.productCode">
                {{ eachId?.productName }} - {{ eachId?.productID }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-component
            [controlName]="babyDefaultOptionsGroup.get('productName')"></app-error-component>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="!(babyDefaultOptionsGroup.valid && babyDefaultOptionsGroup.dirty)"
            class="primary-btn m-2"
            (click)="saveBabyDefaultOptions()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedConfiguration === configOnBoarding.PICKUPS_DEFAULT_OPTIONS">
      <div class="row" [formGroup]="pickupsConfigGroup">
        <div class="col-md-2 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.readyTime' | translate
          }}</label
          >:
          <input class="form-control" formControlName="readyTime" type="time" />
          <div *ngIf="readyError" class="color: red">
            {{ 'configuration.customerOnboarding.noPastTime' | translate }}
          </div>
          <app-error-component
            [controlName]="pickupsConfigGroup.get('readyTime')"></app-error-component>
        </div>

        <div class="col-md-2 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.closeTime' | translate
          }}</label
          >:
          <input class="form-control" formControlName="closingTime" type="time" />
          <div *ngIf="closeError" class="color: red">
            {{ 'configuration.customerOnboarding.closeTimeError' | translate }}
          </div>
          <app-error-component
            [controlName]="pickupsConfigGroup.get('closingTime')"></app-error-component>
        </div>

        <div class="col-md-3 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.location' | translate
          }}</label
          >:
          <input class="form-control" type="text" formControlName="location" />
          <app-error-component
            [controlName]="pickupsConfigGroup.get('location')"></app-error-component>
        </div>

        <div class="col-md-4 form-group">
          <label class="required-field">{{
            'configuration.customerOnboarding.specialInstructions' | translate
          }}</label
          >:
          <textarea
            rows="1"
            class="form-control"
            type="text"
            formControlName="instructions"></textarea>
          <app-error-component
            [controlName]="pickupsConfigGroup.get('instructions')"></app-error-component>
        </div>

        <div class="col-12 mb-2 text-end">
          <button
            [disabled]="
              !(pickupsConfigGroup.valid && pickupsConfigGroup.dirty) || !disablePickupSave()
            "
            class="primary-btn m-2"
            (click)="savePickupConfig()">
            {{ 'global.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
